export default {
      id: "ic_lieu_agenda-usage",
      viewBox: "0 0 15 15",
      url: "../dist/images/" + "sprite.svg#ic_lieu_agenda-usage",
      toString: function () {
        return this.url;
      }
    }